<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br /> {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
            <br />
            <br /> Date: {{ date }}
        </p>
        <p> To Whom It May Concern: </p>
        <p v-for="(account) in accounts" class="letter-content">
            <strong>
                {{ account.furnisher_name }} with account number {{ account.account_number }}
            </strong>
            <template v-if="account.reason">
                <br />
                {{ account.reason }}
            </template>
        </p>
        <p>
            The FTC has noted that providing a copy of a printout, bill, or alleged account documents does not constitute
            validation. Mere itemization of what you already have does not accomplish my requested debt validation.
        </p>
        <p> This is my second request. Please provide me with ALL of the following points of information:</p>
        <ul>
            <li class="letter-content">
                Agreement with the original creditor that authorizes you to collect on this alleged debt and/or verification that this alleged debt was assigned or sold to you.
                <br>
            </li>
            <li class="letter-content">
                The agreement bearing my signature stating that I have agreed to assume the debt
                <br>
            </li>
            <li class="letter-content">
                Valid copies of the debt agreement stating the amount of the debt and interest charges
                <br>
            </li>
            <li class="letter-content">
                Proof that the Statute of Limitations in (Your State) has not expired
                <br>
            </li>

            <li class="letter-content">
                Complete payment history on this account along with an accounting of all additional charges being assessed
                <br>
            </li>
            <li class="letter-content">
                Proof that you are licensed to collect in my state; and
                <br>
            </li>
            <li class="letter-content">
                Your license numbers and Registered Agent or Agent of Service.
                <br>
            </li>
        </ul>
        <p class="letter-content">
            Your non-compliance with my request will also be construed as an absolute waiver of all claims to enforce the debt
            against me and your implied agreement to compensate me for court costs and attorney fees if I am forced to bring this
            matter before a judge.
        </p>
        <p class="letter-content">
            I notice that you are still reporting this collection on my credit report, which is considered to be a collection
            activity. You are now in violation of the FCPDA, and are now subject to fines of $1000, plus actual damages and
            attorney’s fees, which I may collect from you by bringing this issue before a judge.
        </p>
        <p class="letter-content">
            I intend to take all legal steps available to me if I do not hear back from you.
        </p>
        <p>
            Sincerely,
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>
